<div class="order-entry">
    <!-- Header: Contract Symbol & Close -->
    <div class="contract-header" *ngIf="selectedContract">
        <div class="contract-title">
            <!-- <i class="fas fa-star "></i> -->
            <span class="symbol-text">{{ selectedContract.symbol }}</span>
            <!-- <i class="fas fa-times-circle  close-icon"></i> -->
        </div>
        <!-- <div class="contract-stats">
            <span class="badgem multiplier">24h Vol</span>
            <span class="val">1.2M</span>
        </div> -->
    </div>

    <!-- Main Navigation Tabs -->
    <div class="panel-tabs">
        <div class="panel-tab" [class.active]="activeTab === 'order'" (click)="setTab('order')">Place Order</div>
        <div class="panel-tab" [class.active]="activeTab === 'book'" (click)="setTab('book')">Order Book</div>
        <div class="panel-tab" [class.active]="activeTab === 'trades'" (click)="setTab('trades')">Trades</div>
    </div>

    <!-- Tab Content Container -->
    <div class="tab-content-container">

        <!-- 1. Place Order Tab Content -->
        <div class="order-form-content" *ngIf="activeTab === 'order'">
            <!-- Buy/Sell Toggle REMOVED -->

            <div class="d-flex justify-content-between mb-2 avail-balance">
                <span>Avail -- USDT</span>
                <!-- <i class="fas fa-exchange-alt text-warning"></i> -->
            </div>

            <!-- Limit/Market Tabs (Mini) -->
            <!-- <div class="order-type-tabs mini">
                <div class="tab active">Limit</div>
                <div class="tab">Market</div>
            </div> -->

            <!-- Inputs -->
            <div class="input-wrapper">
                <div class="input-box">
                    <input type="number" class="input-field" [(ngModel)]="price" placeholder="Price">
                    <span class="suffix">USDT</span>
                </div>
            </div>

            <div class="input-wrapper">
                <div class="input-box">
                    <input type="text" class="input-field" [(ngModel)]="amount" placeholder="Amount">
                    <span class="suffix">Cont</span>
                </div>
            </div>

            <!-- Slider -->
            <!-- <div class="slider-container">
                <input type="range" class="slider" min="0" max="100" step="25" [(ngModel)]="sliderValue"
                    (change)="onSliderChange(sliderValue)">
                <div class="slider-marks">
                    <span class="mark" [class.active]="sliderValue >= 0"></span>
                    <span class="mark" [class.active]="sliderValue >= 25"></span>
                    <span class="mark" [class.active]="sliderValue >= 50"></span>
                    <span class="mark" [class.active]="sliderValue >= 75"></span>
                    <span class="mark" [class.active]="sliderValue >= 100"></span>
                </div>
            </div> -->

            <!-- Action Button & Fees moved to footer -->
        </div>

        <!-- 2. Order Book Tab Content -->
        <div class="order-book-section" *ngIf="activeTab === 'book'">
            <div class="book-table">
                <div class="book-row table-header">
                    <span class="text-left">Price<br><span class="unit">(USDT)</span></span>
                    <span class="text-right">Size<br><span class="unit">(Cont)</span></span>
                    <span class="text-right">Sum<br><span class="unit">(Cont)</span></span>
                </div>
                <!-- Asks -->
                <div class="book-content asks">
                    <div class="book-row" *ngFor="let ask of asks | slice:0:15; let i=index"
                        (click)="setPrice(ask.price)">
                        <span class="text-sell">{{ ask.price | number:'1.2-3' }}</span>
                        <span class="text-right ">{{ ask.size | number:'1.2-2' }}</span>
                        <span class="text-right ">{{ ask.sum | number:'1.0-2' }}</span>
                    </div>
                </div>
            </div>

            <!-- Spread -->
            <div class="spread-row">
                <span class="calc-price">{{ price | number:'1.2-3' }}</span>
                <span class="spread-percent">Index: 42,000</span>
            </div>

            <!-- Bids -->
            <div class="book-table">
                <div class="book-content bids">
                    <div class="book-row" *ngFor="let bid of bids | slice:0:15" (click)="setPrice(bid.price)">
                        <span class="text-buy">{{ bid.price | number:'1.2-3' }}</span>
                        <span class="text-right ">{{ bid.size | number:'1.2-2' }}</span>
                        <span class="text-right ">{{ bid.sum | number:'1.0-2' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 3. Recent Trades Tab Content -->
        <div class="recent-trades-section" *ngIf="activeTab === 'trades'">
            <div class="book-table">
                <div class="book-row table-header">
                    <span class="text-left">Price<br><span class="unit">(USDT)</span></span>
                    <span class="text-right">Amount<br><span class="unit">(Cont)</span></span>
                    <span class="text-right">Time</span>
                </div>
                <div class="book-content trades-list">
                    <div class="book-row" *ngFor="let trade of recentTrades | slice:0:20"
                        (click)="setPrice(trade.price)">
                        <span [ngClass]="trade.isBuyerMaker ? 'text-sell' : 'text-buy'">{{ trade.price | number:'1.2-3'
                            }}</span>
                        <span class="text-right ">{{ trade.qty | number:'1.3-3' }}</span>
                        <span class="text-right ">{{ trade.time | date:'HH:mm:ss' }}</span>
                    </div>
                    <div *ngIf="recentTrades.length === 0" class="no-data">No Recent Trades</div>
                </div>
            </div>
        </div>

    </div>

    <!-- Sticky Footer for Actions (Always Visible) -->
    <div class="order-footer" *ngIf="activeTab === 'order'">
        <div *ngIf="selectedContract; else noContractBtn" class="footer-actions">
            <!-- Buy Button -->
            <button class="btn-action btn-buy" (click)="placeOrder('BUY')">
                Buy
            </button>
            <!-- Sell Button -->
            <button class="btn-action btn-sell" (click)="placeOrder('SELL')">
                Sell
            </button>
        </div>
        <ng-template #noContractBtn>
            <button class="btn-action btn-disabled" disabled>Select Option</button>
        </ng-template>

        <!-- <div class="fees-row">
            <span>Cost --</span>
            <span>Fee Rate</span>
        </div> -->
    </div>
</div>